export default [
  {
    code: 'id',
    name: 'id',
    type: 'id',
  },
  {
    code: 'shortName',
    name: 'short_name',
    type: 'input',
  },
  {
    code: 'fullName',
    name: 'full_name',
    type: 'input',
  },
  {
    code: 'status',
    name: 'status',
    type: 'select',
    dictionary: 'organizationstatus',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'description',
    name: 'description',
    type: 'input',
  },
  {
    code: 'type',
    name: 'type',
    type: 'select',
    dictionary: 'organizationtype',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'parent',
    name: 'organization_parent',
    type: 'select',
    dictionary: 'organization',
    itemValue: 'id',
    itemText: 'shortName',
  },
  {
    code: 'city',
    name: 'city',
    type: 'select',
    dictionary: 'city',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'region',
    name: 'region',
    type: 'select',
    dictionary: 'region',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'postcode',
    name: 'postcode',
    type: 'input',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'customer',
    name: 'customer',
    type: 'input',
  },
  {
    code: 'securityStock',
    name: 'securityStock',
    label: 'securityStock',
    type: 'number',
    default: {
      comparison: 'GT',
    },
  },
  {
    code: 'deliveryType',
    name: 'delivery_type',
    type: 'select',
    dictionary: 'deliverytype',
    itemValue: 'code',
    itemText: 'name',
  },
]
